// extracted by mini-css-extract-plugin
export var boxItems = "_7w-1";
export var boxItemsLg = "_7w-2";
export var button = "_7w-7";
export var buttonHoverless = "_7w-9";
export var buttonLg = "_7w-8";
export var filterGroupBox = "_7w-0";
export var icon = "_7w-3";
export var iconSecondary = "_7w-6";
export var iconWrapper = "_7w-4";
export var iconWrapperLg = "_7w-5";
export var truncatedLabel = "_7w-a";